/**
 * A wrapper component for use with react-i18next's `Trans` component.
 *
 * Usage:
 *   <Trans i18nKey="ns:key" components={{ a: <TranslationAnchor /> }} />
 */
export const TranslationAnchor = ({
  href,
  children,
}: {
  href?: string;
  children?: React.ReactNode;
}) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);
